import "./style.css";
import "primeicons/primeicons.css";

import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
// import Noir from "./presets/Noir.js";
import Aura from "@primevue/themes/aura";
import axiosInstance from "./boot/axios";
import AuthorService from "./core/services/AuthorService";
import TestimonialService from "./core/services/TestimonialService";
import OptionsService from "./core/services/OptionsService";
import AuthService from "./core/services/AuthService";
import ShareService from "./core/services/ShareService";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import Tooltip from "primevue/tooltip";
import mainRouter from "./router/mainRouter";
import adminRouter from "./router/adminRouter";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
// check https://primevue.org/ for theme generation
// const MyPreset = definePreset(Aura, {});

const app = createApp(App);

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: "p",
            darkModeSelector: ".my-app-dark",
            cssLayer: {
                name: "primevue",
                order: "theme, base, primevue",
            },
        },
    },
});
app.use(mainRouter);
app.use(ConfirmationService);
app.use(ToastService);

app.directive("tooltip", Tooltip);

app.provide("authorService", AuthorService);
app.provide("testimonialService", TestimonialService);
app.provide("optionsService", OptionsService);
app.provide("authService", AuthService);
app.provide("shareService", ShareService);

app.component("Toast", Toast);
app.component("ConfirmDialog", ConfirmDialog);
app.config.globalProperties.$axios = axiosInstance;

app.mount("#app");
